import { showToast, showDialog } from 'vant'
import { VIDEO_CALL_FAILURE_REASON, PERMISSION_TYPE } from '@/stores/videoCall'
import { t } from '@/locales'

/**
 * 显示权限被拒绝的引导弹窗
 * @param {Array<string>} deniedPermissions - 被拒绝的权限列表
 */
export function showPermissionDeniedDialog(deniedPermissions) {
  if (!deniedPermissions || deniedPermissions.length === 0) return

  const permissionNames = deniedPermissions.map(permission => {
    return t(`common.permissions.${permission}`)
  }).join(t('common.and'))

  showDialog({
    title: t('common.permissionDenied.title'),
    message: t('common.permissionDenied.message', { permissions: permissionNames }),
    confirmButtonText: t('common.confirm'),
  })
}

/**
 * Agora 轨道创建错误处理
 * @param {Error} error - Agora SDK 抛出的错误
 * @returns {Object} 返回 { reason, message, deniedPermissions }
 */
export function handleCreateTracksError(error) {
  console.error('[Agora] Failed to create tracks:', error)

  let failureReason = VIDEO_CALL_FAILURE_REASON.UNKNOWN
  let errorMessage = t('videoCall.createTracksFailed')
  const deniedPermissions = []

  // 根据 Agora SDK 的错误码处理不同的错误情况
  switch (error.code) {
    case 'PERMISSION_DENIED':
      // 用户拒绝授予访问摄像头/麦克风的权限
      // 或者屏幕共享选择共享源时，用户没有选择共享源，并关闭了选择窗口
      failureReason = VIDEO_CALL_FAILURE_REASON.PERMISSION_DENIED
      errorMessage = t('common.permissionDenied.title')
      deniedPermissions.push(PERMISSION_TYPE.CAMERA, PERMISSION_TYPE.MICROPHONE)
      showPermissionDeniedDialog(deniedPermissions)
      break

    case 'NOT_SUPPORTED':
      // 使用的功能在当前浏览器上不支持
      failureReason = VIDEO_CALL_FAILURE_REASON.NOT_SUPPORTED
      errorMessage = t('videoCall.browserNotSupported')
      showToast(errorMessage)
      break

    case 'DEVICE_NOT_FOUND':
      // 找不到指定的采集设备
      failureReason = VIDEO_CALL_FAILURE_REASON.DEVICE_NOT_FOUND
      errorMessage = t('videoCall.deviceNotFound')
      showToast(errorMessage)
      break

    case 'MEDIA_OPTION_INVALID':
      // 指定的采集参数无法被满足
      // 一般是因为设备不支持指定的分辨率或帧率
      failureReason = VIDEO_CALL_FAILURE_REASON.MEDIA_OPTION_INVALID
      errorMessage = t('videoCall.mediaOptionInvalid')
      showToast(errorMessage)
      break

    case 'CONSTRAINT_NOT_SATISFIED':
      // 浏览器不支持指定的采集选项
      failureReason = VIDEO_CALL_FAILURE_REASON.CONSTRAINT_NOT_SATISFIED
      errorMessage = t('videoCall.constraintNotSatisfied')
      showToast(errorMessage)
      break

    default:
      // 未知错误
      showToast(errorMessage)
      break
  }

  return {
    reason: failureReason,
    message: errorMessage,
    code: error.code,
    deniedPermissions,
  }
}
